<template>
  <div class="home">
    <header>
    <div class="jumbotron jumbotron-lg jumbotron-fluid mb-0 pb-3 hero-section position-relative">
        <div class="hero-particles" id="particles-js"></div>
        <div class="hero-grid-overlay"></div>
        <div class="hero-gradient-orbs">
            <div class="orb orb-1"></div>
            <div class="orb orb-2"></div>
            <div class="orb orb-3"></div>
        </div>
        <div class="hero-content-wrapper">
            <div class="container-fluid text-white h-100">
                <div class="d-lg-flex align-items-center justify-content-between text-center pl-lg-5">
                    <div class="col pt-4 pb-4">
                        <div class="hero-badge">
                            <span class="badge-inner">专业科技服务</span>
                        </div>
                        <h1 class="hero-title">
                            <span class="title-line">数智化一站式解决方案</span>
                            <span class="title-glow"></span>
                        </h1>
                        <h5 class="hero-subtitle" style="margin-top:30px">
                            <span class="subtitle-text">专业助力软件开发，网站开发，小程序开发</span>
                        </h5>
                        <h5 class="hero-subtitle mb-4">
                            <span class="subtitle-text">服务思维 全新升级</span>
                        </h5>

                        <div class="hero-buttons">
                            <a href="/case" class="btn btn-lg btn-tech-primary btn-round">
                                <span class="btn-content">
                                    <span class="btn-icon">→</span>
                                    <span class="btn-text">案例展示</span>
                                </span>
                                <span class="btn-bg"></span>
                            </a>
                            <a href="/contact" class="btn btn-lg btn-tech-secondary btn-round">
                                <span class="btn-content">
                                    <span class="btn-icon">✉</span>
                                    <span class="btn-text">联系我们</span>
                                </span>
                                <span class="btn-bg"></span>
                            </a>
                        </div>
                    </div>
                    <div class="col align-self-bottom align-items-right h-max-380 h-xl-560 position-relative z-index-1 hero-image-wrapper">
                        <div class="image-frame">
                            <div class="frame-corner frame-corner-tl"></div>
                            <div class="frame-corner frame-corner-tr"></div>
                            <div class="frame-corner frame-corner-bl"></div>
                            <div class="frame-corner frame-corner-br"></div>
                            <img src="/images/bg.png" class="rounded img-fluid hero-image">
                            <div class="image-scan-line"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="wave-container">
            <svg class="wave wave1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" preserveAspectRatio="none">
                <path class="hero-wave wave-path-1" d="M0,192L48,197.3C96,203,192,213,288,229.3C384,245,480,267,576,250.7C672,235,768,181,864,181.3C960,181,1056,235,1152,234.7C1248,235,1344,181,1392,154.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            </svg>
            <svg class="wave wave2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" preserveAspectRatio="none">
                <path class="hero-wave wave-path-2" d="M0,256L48,240C96,224,192,192,288,186.7C384,181,480,203,576,218.7C672,235,768,245,864,234.7C960,224,1056,192,1152,186.7C1248,181,1344,203,1392,213.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            </svg>
            <svg class="wave wave3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" preserveAspectRatio="none">
                <path class="hero-wave wave-path-3" d="M0,288L48,272C96,256,192,224,288,213.3C384,203,480,213,576,229.3C672,245,768,267,864,261.3C960,256,1056,224,1152,213.3C1248,203,1344,213,1392,218.7L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            </svg>
        </div>
    </div>
</header>

    <section class="slice slice-lg solutions-section">
        <div class="container">
            <div class="row mb-5 justify-content-center text-center">
                <div class="col-lg-8">
                    <div class="section-header">
                        <span class="section-badge">核心服务</span>
                        <h2 class="section-title-main">解决方案</h2>
                        <p class="section-subtitle">为您提供全方位的数字化转型服务</p>
                    </div>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-md-4">
                    <div class="solution-card">
                        <div class="card-glow"></div>
                        <div class="card-content">
                            <div class="card-icon-wrapper">
                                <div class="icon-bg"></div>
                                <img src="/images/illustration-5.svg" class="card-icon" alt="网站开发">
                                <div class="icon-ring"></div>
                            </div>
                            <h5 class="card-title">网站开发</h5>
                            <p class="card-description">互联网的日益发展使得一个好的网站是一个企业的第一门面，我们助力于帮助您通过建设网站获得源源不断的流量.</p>
                            <div class="card-footer">
                                <a href="/case" class="card-link">
                                    <span>了解更多</span>
                                    <span class="link-arrow">→</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="solution-card">
                        <div class="card-glow"></div>
                        <div class="card-content">
                            <div class="card-icon-wrapper">
                                <div class="icon-bg"></div>
                                <img src="/images/illustration-6.svg" class="card-icon" alt="APP/小程序开发">
                                <div class="icon-ring"></div>
                            </div>
                            <h5 class="card-title">APP/小程序开发</h5>
                            <p class="card-description">我们日常使用的最多的场景就是APP和小程序了，无论您是餐饮，娱乐，还是政务，出行，我们助力您生成最佳方案.</p>
                            <div class="card-footer">
                                <a href="/case" class="card-link">
                                    <span>了解更多</span>
                                    <span class="link-arrow">→</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="solution-card">
                        <div class="card-glow"></div>
                        <div class="card-content">
                            <div class="card-icon-wrapper">
                                <div class="icon-bg"></div>
                                <img src="/images/illustration-7.svg" class="card-icon" alt="软件开发">
                                <div class="icon-ring"></div>
                            </div>
                            <h5 class="card-title">软件开发</h5>
                            <p class="card-description">日常工作中，我们需要很多场景要借助电脑完成工作，我们助力于您获得便捷实用的各种工具，行业，以及管理软件.</p>
                            <div class="card-footer">
                                <a href="/case" class="card-link">
                                    <span>了解更多</span>
                                    <span class="link-arrow">→</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="slice slice-lg about-section-new">
        <div class="about-bg-pattern"></div>
        <div class="container">
            <div class="py-6">
                <div class="row row-grid justify-content-between align-items-center">
                    <div class="col-lg-4 order-lg-1">
                        <div class="about-image-wrapper">
                            <div class="image-frame-new">
                                <div class="frame-decoration"></div>
                                <img alt="公司大楼" src="/images/building.jpg" class="img-fluid">
                                <div class="image-overlay"></div>
                            </div>
                            <div class="floating-badge">
                                <span class="badge-number">10+</span>
                                <span class="badge-text">年经验</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-8 order-lg-2">
                        <div class="about-content">
                            <div class="section-header-left">
                                <span class="section-badge">关于我们</span>
                                <h2 class="section-title-main">专业的技术团队</h2>
                            </div>
                            <div class="about-features">
                                <div class="feature-item">
                                    <div class="feature-icon">🎓</div>
                                    <div class="feature-content">
                                        <h5>顶尖团队</h5>
                                        <p>团队成员均毕业于国内TOP级别院校，或来自于各大软件互联网厂商，多数成员具有10年以上的互联网、软件开发经验。</p>
                                    </div>
                                </div>
                                <div class="feature-item">
                                    <div class="feature-icon">🚀</div>
                                    <div class="feature-content">
                                        <h5>创新驱动</h5>
                                        <p>成立以来，为响应互联网+、数字化经济、智能制造等新时代号角，为政府、企业提供了丰富的数智化场景解决方案。</p>
                                    </div>
                                </div>
                                <div class="feature-item">
                                    <div class="feature-icon">💼</div>
                                    <div class="feature-content">
                                        <h5>全面服务</h5>
                                        <p>业务范围涵盖了"软件系统研发、物联⽹应⽤研发、智慧平台解决⽅案、基础应⽤型APP⼩程序、⽹站开发、VR/AR 、游戏开发"等。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="about-cta">
                                <a href="/about" class="btn btn-tech-primary btn-round">
                                    <span class="btn-content">
                                        <span class="btn-text">了解更多</span>
                                        <span class="btn-icon">→</span>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="slice slice-lg process-section-new">
        <div class="container">
            <div class="row mb-5 justify-content-center text-center">
                <div class="col-lg-8">
                    <div class="section-header">
                        <span class="section-badge">工作流程</span>
                        <h2 class="section-title-main">合作流程</h2>
                        <p class="section-subtitle">标准化流程，确保项目高质量交付</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="slice pt-0 process-timeline" id="operation">
        <div class="container">
            <div class="timeline-wrapper">
                <div class="timeline-line"></div>
                <div class="row">
                    <div class="col-xl-3 col-sm-6">
                        <div class="process-step">
                            <div class="step-number">
                                <span class="number-text">01</span>
                                <div class="number-glow"></div>
                            </div>
                            <div class="step-content">
                                <h5 class="step-title">需求沟通</h5>
                                <div class="step-details">
                                    <span class="detail-item">需求分析</span>
                                    <span class="detail-item">功能沟通</span>
                                    <span class="detail-item">需求评估</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-sm-6">
                        <div class="process-step">
                            <div class="step-number">
                                <span class="number-text">02</span>
                                <div class="number-glow"></div>
                            </div>
                            <div class="step-content">
                                <h5 class="step-title">达成合作</h5>
                                <div class="step-details">
                                    <span class="detail-item">项目调研</span>
                                    <span class="detail-item">给出报价</span>
                                    <span class="detail-item">成立项目</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-sm-6">
                        <div class="process-step">
                            <div class="step-number">
                                <span class="number-text">03</span>
                                <div class="number-glow"></div>
                            </div>
                            <div class="step-content">
                                <h5 class="step-title">原型交互</h5>
                                <div class="step-details">
                                    <span class="detail-item">原型规划</span>
                                    <span class="detail-item">交互设计</span>
                                    <span class="detail-item">设计确认</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-sm-6">
                        <div class="process-step">
                            <div class="step-number">
                                <span class="number-text">04</span>
                                <div class="number-glow"></div>
                            </div>
                            <div class="step-content">
                                <h5 class="step-title">程序开发</h5>
                                <div class="step-details">
                                    <span class="detail-item">架构设计</span>
                                    <span class="detail-item">数据设计</span>
                                    <span class="detail-item">程序开发</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-3 col-sm-6">
                        <div class="process-step">
                            <div class="step-number">
                                <span class="number-text">05</span>
                                <div class="number-glow"></div>
                            </div>
                            <div class="step-content">
                                <h5 class="step-title">产品测试</h5>
                                <div class="step-details">
                                    <span class="detail-item">开发文档</span>
                                    <span class="detail-item">功能测试</span>
                                    <span class="detail-item">性能测试</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-sm-6">
                        <div class="process-step">
                            <div class="step-number">
                                <span class="number-text">06</span>
                                <div class="number-glow"></div>
                            </div>
                            <div class="step-content">
                                <h5 class="step-title">审核验收</h5>
                                <div class="step-details">
                                    <span class="detail-item">功能验收</span>
                                    <span class="detail-item">程序验收</span>
                                    <span class="detail-item">细节验收</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-sm-6">
                        <div class="process-step">
                            <div class="step-number">
                                <span class="number-text">07</span>
                                <div class="number-glow"></div>
                            </div>
                            <div class="step-content">
                                <h5 class="step-title">产品上线</h5>
                                <div class="step-details">
                                    <span class="detail-item">服务部署</span>
                                    <span class="detail-item">产品发布</span>
                                    <span class="detail-item">运行配置</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-sm-6">
                        <div class="process-step">
                            <div class="step-number">
                                <span class="number-text">08</span>
                                <div class="number-glow"></div>
                            </div>
                            <div class="step-content">
                                <h5 class="step-title">运营维护</h5>
                                <div class="step-details">
                                    <span class="detail-item">运行监控</span>
                                    <span class="detail-item">紧急服务</span>
                                    <span class="detail-item">持续优化</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

   
  </div>
</template>

<script>
import navbar from '../components/navbar.vue';
export default {
  name: 'HomeView',
  components: {
    navbar
  }
}
</script>

<style lang="scss">
.hero-section {
    background: linear-gradient(135deg, #0a0e27 0%, #1a1f3a 30%, #0f2027 70%, #000000 100%) !important;
    position: relative;
    overflow: hidden;
    min-height: 600px;
    padding-top: 80px;
    padding-bottom: 0;

    .hero-particles {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: 
            radial-gradient(circle at 20% 30%, rgba(0, 212, 255, 0.15) 0%, transparent 30%),
            radial-gradient(circle at 80% 70%, rgba(0, 153, 255, 0.15) 0%, transparent 30%),
            radial-gradient(circle at 40% 80%, rgba(0, 212, 255, 0.1) 0%, transparent 25%),
            radial-gradient(circle at 90% 20%, rgba(0, 153, 255, 0.1) 0%, transparent 25%);
        animation: particleFloat 20s ease-in-out infinite;
        pointer-events: none;
    }

    .hero-grid-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: 
            linear-gradient(rgba(0, 212, 255, 0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 212, 255, 0.03) 1px, transparent 1px);
        background-size: 50px 50px;
        animation: gridMove 30s linear infinite;
        pointer-events: none;
    }

    .hero-gradient-orbs {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
        overflow: hidden;

        .orb {
            position: absolute;
            border-radius: 50%;
            filter: blur(80px);
            opacity: 0.3;

            &.orb-1 {
                width: 400px;
                height: 400px;
                background: radial-gradient(circle, rgba(0, 212, 255, 0.4) 0%, transparent 70%);
                top: -100px;
                left: -100px;
                animation: orbFloat1 15s ease-in-out infinite;
            }

            &.orb-2 {
                width: 500px;
                height: 500px;
                background: radial-gradient(circle, rgba(0, 153, 255, 0.3) 0%, transparent 70%);
                bottom: -150px;
                right: -150px;
                animation: orbFloat2 18s ease-in-out infinite;
            }

            &.orb-3 {
                width: 300px;
                height: 300px;
                background: radial-gradient(circle, rgba(0, 212, 255, 0.3) 0%, transparent 70%);
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                animation: orbFloat3 12s ease-in-out infinite;
            }
        }
    }

    .hero-content-wrapper {
        position: relative;
        z-index: 2;
    }

    .hero-badge {
        display: block;
        width: fit-content;
        margin: 0 auto 20px;
        animation: fadeInDown 0.8s ease;

        .badge-inner {
            display: inline-block;
            padding: 8px 20px;
            background: linear-gradient(135deg, 
                rgba(0, 212, 255, 0.2) 0%, 
                rgba(0, 153, 255, 0.2) 100%);
            border: 1px solid rgba(0, 212, 255, 0.3);
            border-radius: 20px;
            color: #00d4ff;
            font-size: 14px;
            font-weight: 500;
            letter-spacing: 1px;
            text-transform: uppercase;
            position: relative;
            overflow: hidden;

            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, 
                    transparent, 
                    rgba(255, 255, 255, 0.2), 
                    transparent);
                animation: shimmer 2s infinite;
            }
        }
    }

    .hero-title {
        font-size: 3.5rem;
        font-weight: 800;
        position: relative;
        margin-bottom: 20px;
        animation: fadeInUp 1s ease;

        .title-line {
            background: linear-gradient(135deg, #ffffff 0%, #00d4ff 50%, #0099ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            position: relative;
            display: inline-block;
        }

        .title-glow {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(135deg, #00d4ff 0%, #0099ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            filter: blur(20px);
            opacity: 0.5;
            animation: titleGlow 3s ease-in-out infinite;
        }
    }

    .hero-subtitle {
        font-weight: 300;
        animation: fadeInUp 1.2s ease;

        .subtitle-text {
            color: rgba(255, 255, 255, 0.85);
            font-size: 1.25rem;
            letter-spacing: 0.5px;
            position: relative;
            display: inline-block;

            &::after {
                content: '';
                position: absolute;
                bottom: -5px;
                left: 0;
                width: 100%;
                height: 1px;
                background: linear-gradient(90deg, 
                    transparent, 
                    rgba(0, 212, 255, 0.5), 
                    transparent);
            }
        }
    }

    .hero-buttons {
        margin-top: 30px;
        animation: fadeInUp 1.4s ease;
        display: flex;
        gap: 20px;
        justify-content: center;
        flex-wrap: wrap;

        .btn-tech-primary,
        .btn-tech-secondary {
            position: relative;
            overflow: hidden;
            border-radius: 30px;
            font-size: 16px;
            font-weight: 600;
            padding: 14px 35px;
            transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);

            .btn-content {
                position: relative;
                z-index: 2;
                display: flex;
                align-items: center;
                gap: 10px;

                .btn-icon {
                    font-size: 18px;
                    transition: transform 0.3s ease;
                }
            }

            .btn-bg {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                transition: all 0.4s ease;
            }

            &:hover {
                transform: translateY(-5px) scale(1.05);

                .btn-icon {
                    transform: translateX(5px);
                }
            }
        }

        .btn-tech-primary {
            background: linear-gradient(135deg, #00d4ff 0%, #0099ff 100%);
            color: white;
            border: none;
            box-shadow: 0 10px 30px rgba(0, 212, 255, 0.4);

            .btn-bg {
                background: linear-gradient(135deg, #0099ff 0%, #0077ff 100%);
                opacity: 0;
            }

            &:hover {
                box-shadow: 0 15px 40px rgba(0, 212, 255, 0.6);

                .btn-bg {
                    opacity: 1;
                }
            }
        }

        .btn-tech-secondary {
            background: transparent;
            color: white;
            border: 2px solid rgba(0, 212, 255, 0.5);
            box-shadow: 0 10px 30px rgba(0, 212, 255, 0.2);

            .btn-bg {
                background: linear-gradient(135deg, rgba(0, 212, 255, 0.2) 0%, rgba(0, 153, 255, 0.2) 100%);
                opacity: 0;
            }

            &:hover {
                border-color: #00d4ff;
                box-shadow: 0 15px 40px rgba(0, 212, 255, 0.4);

                .btn-bg {
                    opacity: 1;
                }
            }
        }
    }

    .hero-image-wrapper {
        animation: fadeInRight 1.2s ease;

        .image-frame {
            position: relative;
            padding: 20px;
            background: rgba(0, 212, 255, 0.05);
            border: 1px solid rgba(0, 212, 255, 0.2);
            border-radius: 20px;
            overflow: hidden;

            .frame-corner {
                position: absolute;
                width: 30px;
                height: 30px;
                border: 2px solid #00d4ff;

                &.frame-corner-tl {
                    top: 0;
                    left: 0;
                    border-right: none;
                    border-bottom: none;
                    border-top-left-radius: 20px;
                }

                &.frame-corner-tr {
                    top: 0;
                    right: 0;
                    border-left: none;
                    border-bottom: none;
                    border-top-right-radius: 20px;
                }

                &.frame-corner-bl {
                    bottom: 0;
                    left: 0;
                    border-right: none;
                    border-top: none;
                    border-bottom-left-radius: 20px;
                }

                &.frame-corner-br {
                    bottom: 0;
                    right: 0;
                    border-left: none;
                    border-top: none;
                    border-bottom-right-radius: 20px;
                }
            }

            .hero-image {
                max-height: 430px;
                filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.3));
                animation: float 4s ease-in-out infinite;
            }

            .image-scan-line {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 2px;
                background: linear-gradient(90deg, 
                    transparent, 
                    rgba(0, 212, 255, 0.8), 
                    transparent);
                animation: scanLine 3s linear infinite;
                pointer-events: none;
            }
        }
    }

    .wave-container {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 150px;
        overflow: hidden;
        pointer-events: none;

        .wave {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100%;

            &.wave1 {
                z-index: 3;
                opacity: 0.8;
            }

            &.wave2 {
                z-index: 2;
                opacity: 0.5;
            }

            &.wave3 {
                z-index: 1;
                opacity: 0.3;
            }
        }

        .hero-wave {
            fill: #ffffff;
            animation: waveMove 10s ease-in-out infinite;
        }

        .wave-path-1 {
            animation: wavePath1 8s ease-in-out infinite;
        }

        .wave-path-2 {
            animation: wavePath2 10s ease-in-out infinite;
        }

        .wave-path-3 {
            animation: wavePath3 12s ease-in-out infinite;
        }
    }
}

@keyframes particleFloat {
    0%, 100% {
        transform: translate(0, 0) scale(1);
    }
    25% {
        transform: translate(20px, -30px) scale(1.1);
    }
    50% {
        transform: translate(-20px, 20px) scale(0.9);
    }
    75% {
        transform: translate(30px, 10px) scale(1.05);
    }
}

@keyframes gridMove {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(50px, 50px);
    }
}

@keyframes orbFloat1 {
    0%, 100% {
        transform: translate(0, 0) scale(1);
    }
    50% {
        transform: translate(100px, 50px) scale(1.2);
    }
}

@keyframes orbFloat2 {
    0%, 100% {
        transform: translate(0, 0) scale(1);
    }
    50% {
        transform: translate(-80px, -60px) scale(1.1);
    }
}

@keyframes orbFloat3 {
    0%, 100% {
        transform: translate(-50%, -50%) scale(1);
    }
    50% {
        transform: translate(-50%, -50%) scale(1.3);
    }
}

@keyframes shimmer {
    0% {
        left: -100%;
    }
    100% {
        left: 100%;
    }
}

@keyframes titleGlow {
    0%, 100% {
        opacity: 0.3;
    }
    50% {
        opacity: 0.6;
    }
}

@keyframes fadeInDown {
    from {
        opacity: 0;
        transform: translateY(-30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeInRight {
    from {
        opacity: 0;
        transform: translateX(50px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes float {
    0%, 100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-15px);
    }
}

@keyframes scanLine {
    0% {
        top: 0;
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        top: 100%;
        opacity: 0;
    }
}

@keyframes waveMove {
    0%, 100% {
        transform: translateX(0);
    }
    50% {
        transform: translateX(-25px);
    }
}

@keyframes wavePath1 {
    0%, 100% {
        d: path("M0,192L48,197.3C96,203,192,213,288,229.3C384,245,480,267,576,250.7C672,235,768,181,864,181.3C960,181,1056,235,1152,234.7C1248,235,1344,181,1392,154.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z");
    }
    50% {
        d: path("M0,160L48,170.7C96,181,192,203,288,213.3C384,224,480,224,576,213.3C672,203,768,181,864,186.7C960,192,1056,224,1152,229.3C1248,235,1344,213,1392,202.7L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z");
    }
}

@keyframes wavePath2 {
    0%, 100% {
        d: path("M0,256L48,240C96,224,192,192,288,186.7C384,181,480,203,576,218.7C672,235,768,245,864,234.7C960,224,1056,192,1152,186.7C1248,181,1344,203,1392,213.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z");
    }
    50% {
        d: path("M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,213.3C672,224,768,224,864,218.7C960,213,1056,203,1152,208C1248,213,1344,235,1392,245.3L1440,256L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z");
    }
}

@keyframes wavePath3 {
    0%, 100% {
        d: path("M0,288L48,272C96,256,192,224,288,213.3C384,203,480,213,576,229.3C672,245,768,267,864,261.3C960,256,1056,224,1152,213.3C1248,203,1344,213,1392,218.7L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z");
    }
    50% {
        d: path("M0,261.3L48,250.7C96,240,192,218.7,288,218.7C384,218.7,480,240,576,250.7C672,261.3,768,261.3,864,256C960,250.7,1056,240,1152,234.7C1248,229.3,1344,229.3,1392,229.3L1440,229.3L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z");
    }
}

.mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 508px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
}
.alpha-7, .alpha-container:hover .alpha-7--hover {
    opacity: 0.7;
}

.card{
  margin-bottom:30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: none;
  border-radius: 15px;
  transition: all 0.3s ease;
  background: white;

  &:hover {
      transform: translateY(-5px);
      box-shadow: 0 15px 40px rgba(0, 212, 255, 0.2);
  }
}

.lh-130{
  color: #1a1f3a;
  font-weight: bold;
}

#operation{
    .badge{
        font-size: 22px;
    }
}

.badge-primary{
    font-size: 18px !important;
    background: linear-gradient(135deg, #00d4ff 0%, #0099ff 100%) !important;
    padding: 8px 16px;
    border-radius: 8px;
}

.btn-primary {
    background: linear-gradient(135deg, #00d4ff 0%, #0099ff 100%);
    border: none;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(0, 212, 255, 0.4);
    }
}

.about-section {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    position: relative;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: 
            radial-gradient(circle at 30% 70%, rgba(0, 212, 255, 0.05) 0%, transparent 50%),
            radial-gradient(circle at 70% 30%, rgba(0, 153, 255, 0.05) 0%, transparent 50%);
        pointer-events: none;
    }
}

.section-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: #1a1f3a;
    position: relative;
    display: inline-block;

    &::after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 60px;
        height: 3px;
        background: linear-gradient(90deg, #00d4ff, #0099ff);
        border-radius: 2px;
    }
}

.about-list {
    text-align: left;
    color: #555;
    font-size: 16px;
    line-height: 1.8;

    li {
        position: relative;
        padding-left: 25px;
        margin-bottom: 15px;

        &::before {
            content: '▸';
            position: absolute;
            left: 0;
            color: #00d4ff;
            font-weight: bold;
        }
    }
}

.about-card {
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
    border-radius: 15px;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 20px 40px rgba(0, 212, 255, 0.2);
    }
}

.process-section {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

.process-cards {
    background: linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%);
}

.process-card {
    position: relative;
    overflow: hidden;
    border: 1px solid rgba(0, 212, 255, 0.1);
    transition: all 0.3s ease;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        background: linear-gradient(90deg, #00d4ff, #0099ff);
        transform: scaleX(0);
        transition: transform 0.3s ease;
    }

    &:hover {
        border-color: rgba(0, 212, 255, 0.3);
        transform: translateY(-8px);
        box-shadow: 0 20px 40px rgba(0, 212, 255, 0.15);

        &::before {
            transform: scaleX(1);
        }
    }
}

.solutions-section {
    padding: 100px 0;
    background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
    position: relative;

    .section-header {
        margin-bottom: 60px;

        .section-badge {
            display: inline-block;
            padding: 8px 20px;
            background: linear-gradient(135deg, rgba(0, 212, 255, 0.1) 0%, rgba(0, 153, 255, 0.1) 100%);
            border: 1px solid rgba(0, 212, 255, 0.3);
            border-radius: 20px;
            color: #00d4ff;
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 1px;
            text-transform: uppercase;
            margin-bottom: 20px;
        }

        .section-title-main {
            font-size: 3rem;
            font-weight: 800;
            background: linear-gradient(135deg, #1a1f3a 0%, #00d4ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            margin-bottom: 15px;
        }

        .section-subtitle {
            color: #666;
            font-size: 1.1rem;
            font-weight: 300;
        }
    }

    .solution-card {
        position: relative;
        background: white;
        border-radius: 20px;
        padding: 40px 30px;
        margin-bottom: 30px;
        transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        overflow: hidden;
        border: 1px solid rgba(0, 212, 255, 0.1);

        .card-glow {
            position: absolute;
            top: -50%;
            left: -50%;
            width: 200%;
            height: 200%;
            background: radial-gradient(circle, rgba(0, 212, 255, 0.1) 0%, transparent 70%);
            opacity: 0;
            transition: opacity 0.4s ease;
            pointer-events: none;
        }

        &:hover {
            transform: translateY(-10px);
            box-shadow: 0 25px 50px rgba(0, 212, 255, 0.2);
            border-color: rgba(0, 212, 255, 0.3);

            .card-glow {
                opacity: 1;
            }

            .icon-ring {
                transform: scale(1.2);
                opacity: 1;
            }

            .card-link {
                color: #00d4ff;

                .link-arrow {
                    transform: translateX(5px);
                }
            }
        }

        .card-content {
            position: relative;
            z-index: 2;

            .card-icon-wrapper {
                position: relative;
                width: 120px;
                height: 120px;
                margin: 0 auto 30px;

                .icon-bg {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(135deg, rgba(0, 212, 255, 0.1) 0%, rgba(0, 153, 255, 0.1) 100%);
                    border-radius: 50%;
                }

                .card-icon {
                    position: relative;
                    width: 80px;
                    height: 80px;
                    object-fit: contain;
                    z-index: 2;
                }

                .icon-ring {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%) scale(1);
                    width: 100%;
                    height: 100%;
                    border: 2px solid rgba(0, 212, 255, 0.3);
                    border-radius: 50%;
                    opacity: 0.5;
                    transition: all 0.4s ease;
                }
            }

            .card-title {
                font-size: 1.5rem;
                font-weight: 700;
                color: #1a1f3a;
                margin-bottom: 15px;
            }

            .card-description {
                color: #666;
                line-height: 1.8;
                margin-bottom: 20px;
                font-size: 0.95rem;
            }

            .card-footer {
                .card-link {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    color: #1a1f3a;
                    font-weight: 600;
                    text-decoration: none;
                    transition: all 0.3s ease;

                    .link-arrow {
                        transition: transform 0.3s ease;
                    }
                }
            }
        }
    }
}

.about-section-new {
    padding: 100px 0;
    background: linear-gradient(135deg, #0a0e27 0%, #1a1f3a 100%);
    position: relative;
    overflow: hidden;

    .about-bg-pattern {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: 
            linear-gradient(rgba(0, 212, 255, 0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 212, 255, 0.03) 1px, transparent 1px);
        background-size: 50px 50px;
        pointer-events: none;
    }

    .about-image-wrapper {
        position: relative;

        .image-frame-new {
            position: relative;
            border-radius: 20px;
            overflow: hidden;
            box-shadow: 0 30px 60px rgba(0, 0, 0, 0.3);

            .frame-decoration {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                border: 2px solid rgba(0, 212, 255, 0.3);
                border-radius: 20px;
                pointer-events: none;
                z-index: 2;
            }

            img {
                width: 100%;
                display: block;
            }

            .image-overlay {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: linear-gradient(135deg, 
                    rgba(0, 212, 255, 0.1) 0%, 
                    rgba(0, 153, 255, 0.1) 100%);
                pointer-events: none;
            }
        }

        .floating-badge {
            position: absolute;
            bottom: -20px;
            right: -20px;
            background: linear-gradient(135deg, #00d4ff 0%, #0099ff 100%);
            color: white;
            padding: 20px;
            border-radius: 15px;
            box-shadow: 0 10px 30px rgba(0, 212, 255, 0.4);
            text-align: center;
            animation: float 3s ease-in-out infinite;

            .badge-number {
                display: block;
                font-size: 2rem;
                font-weight: 800;
            }

            .badge-text {
                display: block;
                font-size: 0.85rem;
                font-weight: 500;
            }
        }
    }

    .about-content {
        .section-header-left {
            margin-bottom: 40px;

            .section-badge {
                display: inline-block;
                padding: 8px 20px;
                background: rgba(0, 212, 255, 0.2);
                border: 1px solid rgba(0, 212, 255, 0.3);
                border-radius: 20px;
                color: #00d4ff;
                font-size: 14px;
                font-weight: 600;
                letter-spacing: 1px;
                text-transform: uppercase;
                margin-bottom: 20px;
            }

            .section-title-main {
                font-size: 2.5rem;
                font-weight: 800;
                color: white;
                margin: 0;
            }
        }

        .about-features {
            .feature-item {
                display: flex;
                gap: 20px;
                margin-bottom: 30px;
                padding: 20px;
                background: rgba(255, 255, 255, 0.05);
                border-radius: 15px;
                border: 1px solid rgba(0, 212, 255, 0.1);
                transition: all 0.3s ease;

                &:hover {
                    background: rgba(255, 255, 255, 0.08);
                    border-color: rgba(0, 212, 255, 0.3);
                    transform: translateX(10px);
                }

                .feature-icon {
                    font-size: 2.5rem;
                    flex-shrink: 0;
                }

                .feature-content {
                    h5 {
                        color: #00d4ff;
                        font-weight: 700;
                        margin-bottom: 10px;
                        font-size: 1.1rem;
                    }

                    p {
                        color: rgba(255, 255, 255, 0.8);
                        line-height: 1.6;
                        margin: 0;
                        font-size: 0.95rem;
                    }
                }
            }
        }

        .about-cta {
            margin-top: 40px;
        }
    }
}

.process-section-new {
    padding: 100px 0 50px;
    background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);

    .section-header {
        margin-bottom: 60px;

        .section-badge {
            display: inline-block;
            padding: 8px 20px;
            background: linear-gradient(135deg, rgba(0, 212, 255, 0.1) 0%, rgba(0, 153, 255, 0.1) 100%);
            border: 1px solid rgba(0, 212, 255, 0.3);
            border-radius: 20px;
            color: #00d4ff;
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 1px;
            text-transform: uppercase;
            margin-bottom: 20px;
        }

        .section-title-main {
            font-size: 3rem;
            font-weight: 800;
            background: linear-gradient(135deg, #1a1f3a 0%, #00d4ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            margin-bottom: 15px;
        }

        .section-subtitle {
            color: #666;
            font-size: 1.1rem;
            font-weight: 300;
        }
    }
}

.process-timeline {
    padding: 50px 0 100px;
    background: linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%);

    .timeline-wrapper {
        position: relative;

        .timeline-line {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 2px;
            height: 100%;
            background: linear-gradient(180deg, #00d4ff 0%, #0099ff 100%);
            opacity: 0.3;
            z-index: 0;
        }

        .process-step {
            position: relative;
            background: white;
            padding: 30px;
            margin-bottom: 30px;
            border-radius: 15px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
            border: 1px solid rgba(0, 212, 255, 0.1);
            transition: all 0.4s ease;
            z-index: 1;

            &:hover {
                transform: translateY(-5px);
                box-shadow: 0 15px 40px rgba(0, 212, 255, 0.2);
                border-color: rgba(0, 212, 255, 0.3);

                .step-number {
                    .number-glow {
                        opacity: 1;
                        transform: translate(-50%, -50%) scale(1.5);
                    }
                }
            }

            .step-number {
                position: relative;
                display: inline-block;
                margin-bottom: 20px;

                .number-text {
                    position: relative;
                    z-index: 2;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 60px;
                    height: 60px;
                    background: linear-gradient(135deg, #00d4ff 0%, #0099ff 100%);
                    color: white;
                    font-size: 1.5rem;
                    font-weight: 800;
                    border-radius: 50%;
                    box-shadow: 0 5px 20px rgba(0, 212, 255, 0.4);
                }

                .number-glow {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%) scale(1);
                    width: 60px;
                    height: 60px;
                    background: radial-gradient(circle, rgba(0, 212, 255, 0.3) 0%, transparent 70%);
                    border-radius: 50%;
                    opacity: 0;
                    transition: all 0.4s ease;
                    z-index: 1;
                }
            }

            .step-content {
                .step-title {
                    font-size: 1.3rem;
                    font-weight: 700;
                    color: #1a1f3a;
                    margin-bottom: 15px;
                }

                .step-details {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 10px;

                    .detail-item {
                        display: inline-block;
                        padding: 6px 15px;
                        background: rgba(0, 212, 255, 0.1);
                        color: #0099ff;
                        border-radius: 20px;
                        font-size: 0.85rem;
                        font-weight: 500;
                    }
                }
            }
        }
    }
}
</style>
